<template>
  <div id="app">
    <div class="bg" :class="{ [$route.name]: true }"></div>
    <div :class="{'app-main': !isLogin }">
      <div class="bg-footer" :class="{ [$route.name]: true }"></div>
      <Header v-if="!$route.meta.hideHeader && $route.path !== '/'" class="header" />
      <router-view v-if="isLogin" :class="{ 'pc-wx-work': isPCWxWork }" />
      <el-main v-else class="main">
        <router-view :class="{ 'pc-wx-work': isPCWxWork }" />
      </el-main>
    </div>
    <Footer v-if="!$route.meta.hideFooter && $route.path !== '/'" class="footer" />
    <EditPassword :visible="showEditPassword" />
    <VideoPreview :visible.sync="videoPreview.visible" :src="videoPreview.url" controls autoplay />
    <RetrievePassword :visible.sync="showRetrievePassword" />
  </div>
</template>

<script>
import { getRoutes } from "@/router";
import {isIE}from '@/utils/device'
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import EditPassword from "@/components/EditPassword.vue";
import VideoPreview from "@/components/VideoPreview.vue";
import RetrievePassword from "@/components/RetrievePassword.vue";

export default {
  components: {
    Header,
    Footer,
    EditPassword,
    VideoPreview,
    RetrievePassword,
  },

  data() {
    let { isWeChat, isPCWxWork } = this.$device;
    return {
      isPCWxWork: isWeChat() || isPCWxWork(),
    };
  },

  computed: {
    isLogin({ $route }) {
      return $route.meta.hideHeader && $route.meta.hideFooter
    },
    showEditPassword({$store}){
      return !!$store.state.user.token && $store.state.user.pwdStatus !== 'changed'
    },
    showRetrievePassword: {
      get({ $store }) {
        return $store.state.form.showRetrievePassword
      },
      set(val) {
        this.$store.commit('form/SET_RETRIEVE_PASSWORD', val)
      }
    },
    videoPreview({$store}) {
      return $store.state.form.videoPreview || {}
    },
  },

  created() {
    this.$device.isMobile() && location.replace('/recruit/h5' + location.hash)
  },
  watch:{
    'videoPreview.visible'(val){
      if(!val){
        this.videoPreview.url=''
      }
    }
  }
};
</script>

<style lang="scss">
$header-gutter: 12px;

#app {
  font-family: $font-family;
  color: #2c3e50;
  height: 100%;
  background: #FAF9FE;
  .bg {
    position: absolute;
    top: $header-height;
    width: 100%;
    height: 400px;
    background: transparent top/auto no-repeat;
    &.Enterprise {
      background-image: url("~@/assets/image/bg_header.png");
    }
    &.EnterpriseDetail {
      background-image: url("~@/assets/image/bg_header.png");
    }
    &.PositionDetail {
      background-image: url("~@/assets/image/bg_header2.png");
    }
    &.DeliverRecord {
      background-image: url("~@/assets/image/bg_header3.png");
    }
  }
  .bg-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 598px;
    background: transparent center/auto no-repeat;
    &.MyResume {
      background-image: url("~@/assets/image/bg_footer.png");
    }
  }
  .app-main {
    position: relative;
    margin: 0 auto;
    padding-bottom: 30px;
    width: 1400px;
    .header {
      height: $header-height;
    }
    .main {
      margin-top: $header-gutter;
      min-height: calc(100vh - #{$header-height} - #{$footer-height} - #{$header-gutter});
      overflow: visible;
    }
    .pc-wx-work {
      // margin: auto;
      // max-width: $wx-work-max-width;
      // box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.08);
    }
    .el-main {
      padding: 0;
    }
  }
  .footer {
    padding: 0;
    line-height: $footer-height;
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

@media screen and (max-width: 1440px) {
  .body-scale {
    zoom: .8;
    &.ie {
      position: relative;
      zoom: 1;
      max-width: 100%;
      display: flex;
      justify-content: center;
      background: #FAF9FE;
      #app{
        zoom: .8;
        width: 1120px;
      }
      .footer {
        width: 1400px;
      }
    }
  }
}
</style>
